module.exports = __webpack_public_path__ + "static/media/Univers-light.03f1706a.woff2";